import _isNumber from "lodash/isNumber";
import _get from "lodash/get";
import { createSelector } from 'reselect';
import * as transunionUtils from "../utils/transunion";
/**
 * @param  {object} identity The state of the redux identity reducer.
 * @return {boolean} Has the user been rate limited by TU
 */

export var isRateLimited = function isRateLimited(identity) {
  return _get(identity, 'flags.createTURateLimited');
};
export var enrollFailed = function enrollFailed(identity) {
  return _get(identity, 'flags.enrollFailed') === true;
};
export var getCreditScore = function getCreditScore(identity) {
  return _get(identity, 'profiles.tu_credit_report_profile.vantage_score_3');
};
export var getCreditScoreBand = function getCreditScoreBand(identity) {
  var score = getCreditScore(identity);
  if (!_isNumber(score)) return 'none';
  if (score > 720) return 'Excellent';
  if (score > 690) return 'Good';
  if (score > 630) return 'Average';
  return 'Bad';
};
export var getCreditScoreRecentChanges = function getCreditScoreRecentChanges(identity) {
  return _get(identity, 'creditHistory.recent_changes');
};
export var getCreditScoreNoChangesData = function getCreditScoreNoChangesData(identity) {
  return _get(identity, 'creditHistory.no_changes_data');
};
export var getCreditAlerts = function getCreditAlerts(identity) {
  return _get(identity, 'creditHistory.alerts');
};
export var getCreditScoreHistory = function getCreditScoreHistory(identity) {
  return _get(identity, 'creditHistory.vantage_score_3_history');
};
export var getCreditPercentUtilizationHistory = function getCreditPercentUtilizationHistory(identity) {
  return _get(identity, 'creditHistory.percent_utilization_history');
};
export var getCreditScoreWeeklyChange = createSelector(getCreditScoreHistory, getCreditScore, function (creditScoreHistory, creditScore) {
  return transunionUtils.getCreditScoreDelta(creditScoreHistory, creditScore, {
    weeks: 1
  });
});
export var getCreditScoreMonthlyChange = createSelector(getCreditScoreHistory, getCreditScore, function (creditScoreHistory, creditScore) {
  return transunionUtils.getCreditScoreDelta(creditScoreHistory, creditScore, {
    weeks: 4
  });
});